import { mapValues, omit, omitBy } from "lodash-es";

import PlatformFilterModel from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformFilterModel";

type PinsSpeedFlag =
  | "cacheLegendRanges"
  | "docValueRecords"
  | "individualPinsSearch"
  | "skipAccessibleCount"
  | "twoPhaseClusters";

export const PINS_SPEED_FLAGS: Readonly<Pick<PlatformFilterModel, PinsSpeedFlag>> = {
  cacheLegendRanges: true,
  docValueRecords: true,
  individualPinsSearch: true,
  skipAccessibleCount: true,
  twoPhaseClusters: true,
};

// fields the alert badges read
export const PIN_BADGE_COLUMNS: readonly string[] = [
  "outOfCadence",
  "overdueActivitiesCount",
  "cadenceDaysOut",
  "cadenceStatus",
  "upcomingActivity",
];

// with strictColumns the server stops adding pin colours itself, so ask for them
export const PIN_NO_LEGEND_COLOR_COLUMNS: readonly string[] = ["color", "stage.color"];

const isIncludeFlag = (_value: unknown, key: string) => /^include[A-Z]/.test(key);

// The server adds the fields an include* flag asks for whatever $columns says, so drop them all.
// Only the top level and each entities.<type> are cleaned; $and/$or conditions are left alone.
export const stripIncludeFlags = (filters: PlatformFilterModel): PlatformFilterModel => {
  const result: PlatformFilterModel = omitBy(filters, isIncludeFlag);
  return filters.entities
    ? {
        ...result,
        entities: mapValues(filters.entities, (entity) => omitBy(entity, isIncludeFlag)),
      }
    : result;
};

export const toLeanPinsRequest = (
  filters: PlatformFilterModel,
  {
    columns,
    withBadges,
    withoutLegends,
  }: { columns: string[]; withBadges?: boolean; withoutLegends?: boolean }
): { $columns: string[]; $filters: PlatformFilterModel } => ({
  $columns: [
    ...columns,
    ...(withBadges ? PIN_BADGE_COLUMNS : []),
    ...(withoutLegends ? PIN_NO_LEGEND_COLOR_COLUMNS : []),
  ],
  $filters: {
    ...omit(stripIncludeFlags(filters), "cadence"),
    ...PINS_SPEED_FLAGS,
    strictColumns: true,
  },
});

export const toCountOnlyPinsFilters = (filters: PlatformFilterModel): PlatformFilterModel => ({
  ...stripIncludeFlags(filters),
  skipAccessibleCount: true,
});
